const task_type_names = ['follow', 'watch', 'scan'];
const assignment_type_names = ['segment', 'agent']
const other_div_names = ['repeat_after']

import { hideSections, showSections, disableFieldsForSections, enableFieldsForSections } from "./helpers";

$(document).on('turbolinks:load', function() {
  $('#channel-list').hide()
  $(".bulk-clone").attr("disabled", true);

  $('.agent-select').select2({
    theme: "bootstrap4",
  });

  $('body').on('click', '.task-row-checkbox', function() {
    if ($(".task-row-checkbox:checked").length > 0){
      $(".bulk-clone").attr("disabled", false);
    } else {
      $(".bulk-clone").attr("disabled", true);
    }
  });

  $('.clone-tasks-btn').click(function() {
    task_ids = []
    $('.task-row-checkbox:checked').each(function(i, obj){
      task_ids.push(obj.id)
    })

    agent_id = $('.agent-select').val()
    perform_after = $('#perform-after-field').val()

    $.ajax({
      url: "/tasks/bulk_clone",
      method: "POST",
      data: { task_ids: task_ids, agent_id: agent_id, perform_after: perform_after },
      success: (response) => {
        if(response.status == "success"){
          $('#clone_modal').modal('hide');
          setTimeout(function(){ location.reload() }, 1000);
        } else {
          alert("Please provide complete data");
        }
      },
      error: function(response) {
        console.log('Something went wrong. Please try again.');
      }
    });

  });

  $('body').on('click', '#watch_field .add-button', function(e) {
    e.preventDefault();
    var link_div = "<input class='form-control' name='task[video_links][]' placeholder='Video Link' type='text'>"
    var duration_div = "<input class='form-control' name='task[watch_durations][]' placeholder='Duration' type='number'>"
    var add_btn = "<button class='btn btn-outline-success add-button' type='button'><i class='fa fa-plus' aria-hidden='true'></i></button>"
    var delete_icon = "<i class='fa fa-times' aria-hidden='true'></i>"

    $(this).empty().removeClass("btn-outline-success add-button").addClass("btn-outline-danger remove-button").append(delete_icon)

    $("#watch_field").append("<div class='row mt-3'></div>")
    $("#watch_field .row:last-child").append("<div class='col-md-3'><div>")
    $("#watch_field .row:last-child").append("<div class='col-md-5 video-link'><div>")
    $("#watch_field .row:last-child .video-link").append(link_div)
    $("#watch_field .row:last-child").append("<div class='col-md-3 duration-field'><div>")
    $("#watch_field .row:last-child .duration-field").append(duration_div)
    $("#watch_field .row:last-child").append("<div class='col-md-1 button'><div>")
    $("#watch_field .row:last-child .button").append(add_btn)
  });

  $('body').on('click', '.remove-button', function(e) {
    e.preventDefault();
    $(this).parents(".row")[0].remove();
  });

  $('.load-channels').click(function(){

    $('.channel-checkbox').each(function () {
      if(this.checked){
        var elem = $(this)
        var div = "<option selected='selected' value='"+elem.val()+"' data-uid='"+elem.data("uid")+"'>"+elem.data("name")+"</option>"
        $('#channel_select, #channel_select2').append(div)
      }
    });

    $('#list_modal').modal('hide');
  });

  $('#agentSelect').change(function(){
    let url = new URL(window.location.href);

    if($(this).val()){
      var val = $(this).val()
      url.searchParams.set('agent', val)

    } else {
      url.searchParams.delete('agent')
    }

    window.location.href = url.href;
  });

  $('#list-select').change(function(){
    var val = $(this).val()
    console.log(val)
    $('#channel-list').empty()

    if(val != "Choose"){
      $.ajax({
        url: "/lists/"+val+"/get_channels.json",
        success: (response) => {
          
          response.channels.forEach((obj) => {
            $('#channel-list').append("<div class='m-3'><input type='checkbox' class='channel-checkbox' checked value='"+obj.id+"' data-uid='"+obj.channel_uid+"' data-name='"+obj.channel_name+"'> "+ obj.channel_name +" <b>@"+ obj.channel_uid +"</b></div>");
          });

          $('#channel-list').show()
        },
        error: function(response) {
          console.log('Something went wrong. Please try again.');
        }
      });
    }
  });

  initializeChannelSelect2Field();
  initializeListSelect2Field();
  initializeDivs();

  $('select#task_type').on('change', function() {
    var type = this.value;
    
    if (type){
      showSections([type]);
      var other_types = [...task_type_names]

      const index = other_types.indexOf(type);
      if (index > -1) {
        other_types.splice(index, 1);
      }

      enableFieldsForSections([type])
      hideSections(other_types)
      disableFieldsForSections(other_types)
    } else {
      hideSections(task_type_names)
      disableFieldsForSections(task_type_names)
    }

  });

  $('#task_recurring').change(function(){
    var checked = $(this).prop('checked');

    if (checked) {
      showSections(['repeat_after'])
    } else {
      hideSections(['repeat_after'])
    }

  });

  $('.assign-radios').change(function(){
    var value = $(this).val()

    if(value == "segment"){
      $('#segment_field').show();
      $('#agent_field').hide();
      $('#task_agent_id').val("");
    } else {
      $('#segment_field').hide();
      $('#agent_field').show();
      $("#task_segment_id").val("");
    }
  })
});

function initializeListSelect2Field(){
  $('#list-select').select2({
    ajax: {
      url: '/lists_search.json',
      dataType: 'json',
    },
    templateResult: function (res) {
      var $container = null
      $container = $("<div>" + res.text + "</div>");

      return $container;
    }
  });
}

function initializeChannelSelect2Field(){
  $('.channel-select').select2({
    ajax: {
      url: '/channels_search.json',
      delay: 300,
      dataType: 'json',
    },
    templateResult: function (res) {
      var profile_url = res.default_img_url
      var url = res.url
      var text = res.text

      if (res.disabled){
        url = "https://cdn.business2community.com/wp-content/uploads/2017/08/blank-profile-picture-973460_640.png"
      }

      if(url === null || url === undefined || typeof url === 'undefined' || url === '') {
        url = profile_url
      }

      var $container = null

      if (res.disabled){
        $container = $("<div>" + text + "</div>");
      } else {
        $container = $(
          "<div class='d-flex align-items-center'>" +
            "<div class='thumbnail-link'>" + 
              "<img class='rounded-circle' src='"+url+"' onerror='this.src=\""+profile_url+"\"'></img>" +
            "</div>" +
            "<div class='d-block pl-2'>" +
              "<div class='text-primary'>"+text+"</div>" +
              "<div><small class='text-muted'>"+"@"+res.uid+"</small></div>"+
            "</div>" +
          "</div>");
      }

      return $container;
    },
    templateSelection: function(data) {
      if (!data.id) {
        return data.text;
      }

      var $container = null;
      if (data.selected){
        var uid = $(data.element).data().uid
        $container = $("<span>"+data.text+ "<b> @"+ uid +"</b></span>")
      } else {
        $container = $("<span>"+data.text+ "<b> @"+ data.uid +"</b></span>")
      }
      return $container;
    }
  });
}

function initializeDivs(){
  hideSections(task_type_names.concat(assignment_type_names).concat(other_div_names));
  disableFieldsForSections(task_type_names)

  var type_selected = $('select#task_type').val();

  if (type_selected){
    showSections([type_selected]);
    enableFieldsForSections([type_selected]);
  }

  if($('#agent-radio').is(':checked') ){
    showSections(['agent']);
  }

  if($('#segment-radio').is(':checked') ){
    showSections(['segment']);
  }
}